import { createSelector } from 'reselect';

export const selectedAttributionManagerStore = (state: any) => {
  return state.get('attributionManager');
};

const makeSelectUserInboxes = () =>
  createSelector(selectedAttributionManagerStore, claims => {
    if (claims && claims.get('usersInboxes')) {
      return claims.get('usersInboxes').toJS();
    }
    return [];
  });
const makeSelectManagers = () =>
  createSelector(selectedAttributionManagerStore, claims => {
    if (claims && claims.get('managers')) {
      return claims.get('managers').toJS();
    }
    return [];
  });
const makeSelectCountInboxes = () =>
  createSelector(selectedAttributionManagerStore, claims => {
    if (claims && claims.get('countInboxes')) {
      return claims.get('countInboxes').toJS();
    }
    return [];
  });
export { makeSelectUserInboxes, makeSelectManagers, makeSelectCountInboxes };
